<ng-container *ngIf="vm$ | async as vm">
	<header class="flex flex-col gap-4 mb-4">
		<div class="page-header">
			<div class="flex items-center justify-start gap-4">
				<h2>Requisition Templates</h2>
				<app-button
					btn="primary"
					[icon]="ICON.ADD"
					intercomAttr="add-new-document-btn"
					(click)="openCreateCustomRequisition()"
					id="requisitions-add"
					size="small"
					[testHook]="testHooks.RequisitionsAddButton"
					>Add new</app-button
				>
			</div>
		</div>
		<div class="flex justify-between">
			<atomic-button-group
				[(ngModel)]="currentFilter"
				[options]="filters"
			></atomic-button-group>
			<app-input
				[(ngModel)]="searchTerm"
				placeholder="Search Requisition Templates"
				class="flex-none w-64"
			>
			</app-input>
		</div>
	</header>
	<div
		class="flex min-h-0 flex-grow bg-white rounded-t-xl border-grey-lighter border"
	>
		<section class="flex flex-col flex-1 border-grey-lighter border-r">
			<h3
				class="text-start p-4 bg-grey-lightest align-middle text-lg"
				id="name-title"
			>
				Name
			</h3>

			<ul class="overflow-y-auto" aria-labelledby="name-title">
				<li
					*ngFor="
						let requisition of vm.requisitions
							| filterV2: filterFunction : searchTerm : currentFilter;
						trackBy: trackByRequisitionId
					"
				>
					<button
						class="flex justify-between items-center w-full text-start py-5 px-4 focus-visible:border-green focus-visible:ring-2 focus-visible:ring-green-light hover:bg-grey-lightest transition-colors duration-200 border-grey-lighter border-t"
						[ngClass]="{
							'selected-requisition':
								requisition.id === vm.selectedRequisition?.id,
						}"
						(click)="onSelect(requisition)"
						[testHook]="testHooks.SelectButton"
					>
						<span>
							{{ requisition.name }}
						</span>
						<ng-container
							*ngIf="requisition.closerDefault; else customLabel"
						></ng-container>
					</button>
				</li>
			</ul>
		</section>
		<section class="flex flex-col flex-1">
			<div
				class="text-start flex justify-between items-center p-4 gap-2 border-grey-lighter border-b"
			>
				<div class="flex items-center gap-4" *ngIf="vm.selectedRequisition">
					<h3 class="text-lg">
						{{ vm.selectedRequisition.name }}
					</h3>
					<ng-container
						*ngIf="vm.selectedRequisition.closerDefault; else customLabel"
					></ng-container>
				</div>
				<atomic-kebab-options
					[itemGroups]="[{ items: vm.selectedRequisitionOptions }]"
					(onSelect)="onSelectOption($event)"
				></atomic-kebab-options>
			</div>

			<div class="flex flex-col gap-4 px-8 py-4">
				<h4 class="text-base mb-0">Requisition Information</h4>
				<ul
					*ngIf="vm.selectedRequisition; else noRequisitionPrecedent"
					class="flex flex-col gap-2"
				>
					<li *ngFor="let field of vm.selectedRequisition.fields | keyvalue">
						{{ field.value.label }}
					</li>
				</ul>
			</div>
			<fieldset class="flex flex-col gap-4 px-8 py-4 flex-auto">
				<h4 class="text-base mb-0">Requisition Text</h4>
				<app-requisition-text-areas
					[ngModel]="vm.selectedRequisition"
					disabled
				></app-requisition-text-areas>
			</fieldset>
		</section>
	</div>
</ng-container>

<ng-template #customLabel>
	<span class="bg-grey-lighter text-grey-dark p-2 text-xs rounded-sm">
		Custom
	</span>
</ng-template>
